let employeeShiftTypes = [
  { value: "12H-DAY", label: "JOUR" },
  { value: "12H-NIGHT", label: "NUIT" },
  { value: "NONE", label: "ALTERNE" },
];

export default employeeShiftTypes;
